<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useSEO } from '../composables/useSEO'

interface BreadcrumbItem {
  name: string
  url: string
}

const props = defineProps<{
  items: BreadcrumbItem[]
}>()

const { updateMetaTags } = useSEO()

// Generar datos estructurados para BreadcrumbList
const breadcrumbSchema = computed(() => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: props.items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url
  }))
}))

onMounted(() => {
  // Actualizar SEO con breadcrumbs
  updateMetaTags({
    breadcrumbs: props.items
  })

  // Agregar schema de breadcrumbs
  let schemaScript = document.querySelector('script[data-breadcrumbs-schema]')
  if (!schemaScript) {
    schemaScript = document.createElement('script')
    schemaScript.setAttribute('type', 'application/ld+json')
    schemaScript.setAttribute('data-breadcrumbs-schema', 'true')
    document.head.appendChild(schemaScript)
  }
  schemaScript.textContent = JSON.stringify(breadcrumbSchema.value)
})
</script>

<template>
  <nav class="breadcrumbs" aria-label="Breadcrumb">
    <ol class="breadcrumbs-list">
      <li v-for="(item, index) in items" :key="index" class="breadcrumb-item">
        <router-link
          v-if="index < items.length - 1"
          :to="item.url"
          class="breadcrumb-link"
        >
          {{ item.name }}
        </router-link>
        <span v-else class="breadcrumb-current">{{ item.name }}</span>
        <span v-if="index < items.length - 1" class="breadcrumb-separator">→</span>
      </li>
    </ol>
  </nav>
</template>

<style scoped>
.breadcrumbs {
  margin-bottom: 20px;
}

.breadcrumbs-list {
  display: flex;
  align-items: center;
  gap: 8px;
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 14px;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.breadcrumb-link {
  color: #1297ef;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb-link:hover {
  color: #0d5fef;
  text-decoration: underline;
}

.breadcrumb-current {
  color: #64748b;
  font-weight: 500;
}

.breadcrumb-separator {
  color: #cbd5e1;
  margin: 0 4px;
}
</style>

